import { render, staticRenderFns } from "./Importdata.vue?vue&type=template&id=645cba3e&scoped=true&"
import script from "./Importdata.vue?vue&type=script&lang=js&"
export * from "./Importdata.vue?vue&type=script&lang=js&"
import style0 from "./Importdata.vue?vue&type=style&index=0&id=645cba3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cba3e",
  null
  
)

export default component.exports